module.exports = __webpack_public_path__ + "img/logo-hotelv-nesplein.228a8b3b98d0fe5b5d60091c71c1321f.svg";